module.exports = __webpack_public_path__ + "static/img/x.8d37dd59.png";